module.exports = __webpack_public_path__ + "img/f.f138fe0a.jpg";